// React
import React from 'react';

// Packages
import _groupBy from 'lodash.groupby';
import t from 'prop-types';
import cc from 'classcat';

// Utilities
import { useLabels } from 'utilities/hooks';

// Components
import BorderBox from 'components/borderBox';

const EmployeesFundedOverviewComponent = ({ employees }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { getValueLabel } = useLabels();

    // ///////////////////
    // DATA
    // ///////////////////

    const employeesByType = _groupBy(employees, x => x.Role_Type__c);

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <div className="grid grid-cols-4 gap-16">
            {Object.entries(employeesByType).map(([key, value]) => (
                <BorderBox
                    key={key}
                    theme="amber"
                    className="col-span-2 md:col-span-1">
                    <span className="t-h1">{value.length}</span>
                    <p className="t-sh7 text-blue-60">
                        {getValueLabel(
                            'Initiative_Employee_Funded__c.Role_Type__c',
                            key
                        )}
                    </p>
                </BorderBox>
            ))}
        </div>
    );
};

EmployeesFundedOverviewComponent.propTypes = {};

EmployeesFundedOverviewComponent.defaultProps = {};

export default EmployeesFundedOverviewComponent;
